import React from "react";
import { Download } from "lucide-react";

const WindowsLogo = () => (
    <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor" aria-hidden="true">
        <path d="M3 5.1 10.4 4v7.1H3V5.1Zm0 13.8 7.4 1.1v-7H3v5.9Zm8.3 1.2L21 21.5V13h-9.7v7.1ZM11.3 3.9V11H21V2.5l-9.7 1.4Z" />
    </svg>
);

export const WindowsDownload = () => {
    if (typeof window !== "undefined" && window.dentdefter?.isDesktop) return null;
    return (
        <div className="mt-5 text-center" data-testid="windows-download-section">
            <a
                href="/downloads/DentDefter-Setup.exe"
                download
                data-testid="windows-download-btn"
                className="group inline-flex items-center gap-2.5 px-5 py-2.5 rounded-full border border-slate-300 bg-white/70 backdrop-blur text-slate-800 text-sm font-semibold shadow-sm hover:border-[#00A896] hover:text-[#0F4C5C] hover:-translate-y-0.5 hover:shadow-md transition-[transform,box-shadow,border-color,color] duration-200"
            >
                <WindowsLogo />
                Windows için İndir
                <Download className="w-4 h-4 opacity-60 group-hover:translate-y-0.5 transition-transform" />
            </a>
            <p className="text-[11px] text-slate-400 mt-2">Windows 10/11 • 64-bit • ~84 MB</p>
        </div>
    );
};
